import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthStore } from '../..';
import useSendActivationData from '../../hooks/useSendActivationData';
import IUserActivationResponse from '../../interfaces/IUserActivationResponse';
import commonStyles from '../Common.module.css';
import Spinner from '../spinners/Spinner';
import styles from './Login.module.css';

function AccountActivation() {
    const { token } = useParams();
    const sendActivationData = useSendActivationData();
    const authStore = useAuthStore();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [title, setTitle] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isAgreedWithAgreement, setIsAgreedWithAgreement] = useState(false);
    const [activationData, setActivationData] = useState<IUserActivationResponse | null>(null);

    useEffect(() => {
        authStore.getActivationData(token!)
            .then(response => {
                setActivationData(response);
                setFirstName(response.firstName);
                setLastName(response.lastName);
                setTitle(response.title);
            });
    }, [token]);

    const activateAccount = async () => {
        if (!activationData || !activationData.email || !token || !password || password !== confirmPassword || !isAgreedWithAgreement)
            return;

        await sendActivationData({
            activationToken: token!,
            firstName,
            lastName,
            title,
            password,
        });

        await authStore.login(activationData!.email, password, true);
    };

    return (
        <div className={styles.background}>
            <div className={styles.container} onKeyUp={e => e.key === "Enter" && activateAccount()}>
                <a href="/" className={styles.logoLink}></a>
                <div className={styles.row}>
                    Please confirm the details below and choose a password to complete the activation process.
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        FIRST NAME
                        <input
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        LAST NAME
                        <input
                            value={lastName}
                            onChange={e => setLastName(e.target.value)}
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    Company: {activationData?.companyName}
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        TITLE
                        <input
                            value={title}
                            onChange={e => setTitle(e.target.value)}
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        PASSWORD
                        <input
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    <label className={styles.label}>
                        CONFIRM PASSWORD
                        <input
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            type="password"
                        />
                    </label>
                </div>
                <div className={styles.row}>
                    <label className={styles.checkboxLabel}>
                        <input
                            checked={isAgreedWithAgreement}
                            onChange={e => setIsAgreedWithAgreement(e.target.checked)}
                            type="checkbox"
                        /> I agree to the Recity <a href="https://recity.co/application-use-agreement.htm" target="_blank" className={commonStyles.link}>Application Use Agreement</a>
                    </label>
                </div>
                <div className={[styles.rowHigh, styles.rowRight].join(" ")}>
                    {authStore.isLoading ? (
                        <Spinner className={styles.loginSpinner} />
                    ) : (
                        <button className={commonStyles.primaryButton} onClick={activateAccount}>
                            Activate Account
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default observer(AccountActivation);